exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".load_block[data-v-41679b82]{opacity:.3;pointer-events:none}.load_transition[data-v-41679b82]{transition:.2s}.form-group[data-v-41679b82]{margin-bottom:15px}", ""]);

// exports
